import { Typography } from '@mui/material';

import ChartBoxMultipleOutline from '@/assets/icons/ChartBoxMultipleOutline';
import { Permission } from '@/entities/permissions';
import AccordionSection from '@/features/DataHub/components/AccordionSection';
import BasicUserPreview from '@/features/DataHub/components/Preview/BasicUserPreview';
import { SELECTOR_MODES } from '@/features/SymbolSelector/store/symbolSelector.slice';
import { useAppSelector } from '@/hooks/redux-hooks';
import usePermission from '@/shared/hooks/usePermission';

import Preview from '../Preview';

const PreviewAccordion = () => {
  const { hasPermission } = usePermission();
  const selectorMode = useAppSelector(state => state.symbolSelector.selectorMode);
  const isForwardCurve = selectorMode === SELECTOR_MODES.FORWARD_CURVE;

  return (
    <AccordionSection
      icon={<ChartBoxMultipleOutline />}
      title='Chart view'
    >
      {!isForwardCurve && (
        <Typography
          sx={{
            fontSize: '12px',
            color: 'text.subtext',
            mb: '16px'
          }}
        >
          Chart displays up to 6 items
        </Typography>
      )}
      {hasPermission(Permission.ExportDataChartPreview) ? (
        <Preview showLegend />
      ) : (
        <BasicUserPreview />
      )}
    </AccordionSection>
  );
};

export default PreviewAccordion;
